<template>
  <el-table
    :data="hrData"
    :show-header="false"
    border
  >
    <el-table-column
      prop="label"
    >
      <template slot-scope="scope">
        <strong>{{ scope.row.label }}</strong>
      </template>
    </el-table-column>
    <el-table-column
      prop="value"
    >
      <template slot-scope="scope">
        <el-tag type="danger" size="small" v-if="scope.row.tag">{{ scope.row.value }}</el-tag>
        <span v-if="!scope.row.tag">{{ scope.row.value }}</span>
      </template>
    </el-table-column>
  </el-table>
</template>
<script>
  export default {
    props: ['userData'],
    data() {
      return {
        hrData: [],
      }
    },
    watch: {
      userData(newVal) {
        this.hrData =  [
          {
            label: 'Becenév',
            value: newVal.nick_name || ''
          },
          {
            label: 'Születési név',
            value: newVal.birth_name || '',
          },
          {
            label: 'Születési hely',
            value: newVal.birth_place || '',
          },
          {
            label: 'Születési idő',
            value: this.$options.filters.dateTime(newVal.birth_date),
          },
          {
            label: 'Szig. szám',
            value: newVal.id_card_number || ''
          },
          {
            label: 'TB szám',
            value: newVal.social_insurance_number || ''
          },
          {
            label: 'Adóazonosító jel',
            value: newVal.tax_id_number || ''
          },
          {
            label: 'Adószám',
            value: newVal.tax_number || ''
          },
          {
            label: 'Privát E-mail',
            value: newVal.private_email || ''
          },
          {
            label: 'Privát Mobil',
            value: newVal.private_mobile || ''
          },
          {
            label: newVal.locations.length > 1 ? 'Területek' : 'Terület',
            value: newVal.locations.length === 0 ? 'Nincs terület' : newVal.locations.map(r => r.value).join(', '),
            tag: newVal.locations.length === 0,
          },
          {
            label: 'Területi vezető',
            value: newVal.leader_user ? newVal.leader_user.last_name +' '+ newVal.leader_user.first_name : ''
          },
        ];
      }
    }
  }
</script>
